import {axiosInstanceWithToken}  from "../utils/Client";

export default class AdminHomeService {

    static getDefaultAgencyProfile = (locationId) => {
        return axiosInstanceWithToken.get(`/default_profile/${locationId}/`);
    };

    static getLoginStatus = (locationId, allLocation=1) => {
        return axiosInstanceWithToken.get(
            `/login_status/${locationId}/?all_location=${allLocation}`
        );
    };

    static getActivityLogList = (locationId, page=1, allLocation=1) => {
        return axiosInstanceWithToken.get(
            `/activity_log/${locationId}/?page=${page}&all_location=${allLocation}`
        );
    };

    static getUserActivityLogList = (logId) => {
        return axiosInstanceWithToken.get(`/activity_log/users/${logId}/`);
    };

    static getUserRecognitionList = (locationId, allLocation=1) => {
        return axiosInstanceWithToken.get(
            `/recognition/${locationId}/?all_location=${allLocation}`
        );
    };

    static getPTORequestStatus = (locationId, allLocation=1) => {
        return axiosInstanceWithToken.get(
            `/pto/request/status/${locationId}/?all_location=${allLocation}`
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/AdminHomeService.js